import store from '@/store'
import jwtDecode from 'jwt-decode'
import _ from 'lodash'
import $ from 'jquery'

function getClaim(claim) {
  const token = _.get(store, 'getters.authenticationData.accessToken')
  const claims = token && jwtDecode(token)
  return claims && claims[claim]
}

function hasRole(role) {
  const userRoles = getUserRoles()
  const currentRoles = _.isArray(userRoles) ? userRoles : [userRoles]
  return _.includes(currentRoles, role)
}

function getUserRoles() {
  const userRoles = getClaim('role')
  if (!userRoles) {
    return []
  }
  return _.isArray(userRoles) ? userRoles : [userRoles]
}

function getMockLogins() {
  const defer = $.Deferred()
  if(process.env.NODE_ENV === 'development') {
    import('@/../mocks/db.json').then(data => {
      const result = _.map(data.default.token, token => {
        const decoded = jwtDecode(token.accessToken)
        return { name: decoded.unique_name, role: decoded.role }
      })
      defer.resolve(result)
    })
  } else {
    defer.reject()
  }
  return defer.promise()
}

export default { hasRole, getClaim, getMockLogins, getUserRoles }
